import { RichTextBase, type RichTextOptionalProps } from '../../rich-text-base'

import { richTextRenderOptions } from './rich-text-render-options'

export function RichText(props: RichTextOptionalProps) {
  return <RichTextBase renderOptions={richTextRenderOptions} {...props} />
}
